import { IDaySchedule } from '../../models';
import { checkPart } from './check-part';

export function scheduleIsInsideDefaultSchedule(
  defaultSchedule: IDaySchedule,
  schedule: IDaySchedule
): boolean {
  if (!defaultSchedule.first) {
    return !schedule.first;
  }
  if (!schedule.first) {
    return true;
  }
  const defaultScheduleOverlaps = defaultSchedule.second
    && defaultSchedule.second.begin < defaultSchedule.first.end;
  if (defaultScheduleOverlaps) {
    defaultSchedule = {
      first: { begin: defaultSchedule.first.begin, end: defaultSchedule.second.end },
      second: null,
    };
  }

  if (!checkPart(defaultSchedule, schedule.first)) {
    return false;
  }
  if (schedule.second && !checkPart(defaultSchedule, schedule.second)) {
    return false;
  }
  return true;
}
